import * as fromFreelancer from '../actions/freelancer.action';
import {User} from '../../../users/user';

export interface FreelancerState {
  users: User[];
  freelancer: User[];
  loading: boolean;
  loaded: boolean;
  error: string;
}

export const initialState = {
  users: null,
  loading: false,
  freelancer:null,
  loaded: true,
  error: null
};

export function reducer(state = initialState, action: fromFreelancer.FreelancerAction): FreelancerState {
  switch (action.type) {
    case fromFreelancer.GET_ASSIGNED_FREELANCERS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromFreelancer.GET_ASSIGNED_FREELANCERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: action.payload,
        error: null
      };
    }
    case fromFreelancer.GET_ASSIGNED_FREELANCERS_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: null,
        error: action.payload
      };
    }

    case fromFreelancer.GET_FREELANCER: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromFreelancer.GET_FREELANCER_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: action.payload,
        error: null
      };
    }
    case fromFreelancer.GET_FREELANCER_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: null,
        error: action.payload
      };
    }

    case fromFreelancer.GET_APPROVED_FREELANCERS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromFreelancer.GET_APPROVED_FREELANCERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: action.payload,
        error: null
      };
    }
    case fromFreelancer.GET_APPROVED_FREELANCERS_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: null,
        error: action.payload
      };
    }
    case fromFreelancer.UPDATE_ASSIGNED_FREELANCERS_SUCCESS: {
      return {
        ...state,
        users: action.payload,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromFreelancer.UPDATE_ASSIGNED_FREELANCERS: {
      return {
        ...state,
        users: action.payload,
        loading: false,
        loaded: true,
        error: null
      };
    }
    case fromFreelancer.UPDATE_ASSIGNED_FREELANCERS_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
      };
    }

  }
  return state;
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/freelancers/store/reducers/freelancer.reducer.ts